export { default as MarketingCarousel } from './MarketingCarousel';
